import React from "react";
import T from "prop-types";
import { Close, Footer, Header, Modal } from "MODULES/shared/components/Modal";
import { Col } from "react-bootstrap";
import { Stat } from "MODULES/shared/components";
import numeral from "numeral";
import Body from "MODULES/shared/components/Modal/Body";
import FormRow from "MODULES/shared/components/Forms/FormRow";

function PerLocationModal({ purchasesData, open, setOpen }) {
  return (
    <React.Fragment>
      <Modal open={open} close={() => setOpen(false)} dialogClass="modal-sm">
        <Header>
          <Close close={() => setOpen(false)} />
          <h4 className="modal-title">Purchases By Location</h4>
        </Header>
        <Body>
          <FormRow>
            {purchasesData.perLocation.map(l => (
              <Col md={4} lg={4}>
                <Stat
                  label={`$ Purchases ${l.name}`}
                  value={numeral(l.total_purchases).format("($0,0)")}
                />
              </Col>
            ))}
          </FormRow>
        </Body>
        <Footer>
          <button className="btn btn-primary" onClick={() => setOpen(false)}>
            Close
          </button>
        </Footer>
      </Modal>
    </React.Fragment>
  );
}

PerLocationModal.propTypes = {
  purchasesData: T.shape({}),
  open: T.bool,
  setOpen: T.func
};
export default PerLocationModal;



// WEBPACK FOOTER //
// ./app/modules/PurchasesDashboard/Components/PerLocationModal.jsx